<template>
  <div>
    <p class="body1 text-center accessTitle__title" data-private>
      {{ title }}
    </p>

    <p class="body-1 text-center my-6">
      {{ description }}
    </p>

    <GoTo
      testId="forgotPassword-button-backLogin"
      :linkMessage="$t('authManagePeople.go_back_to_login')"
      @onClickGoTo="$emit('onGoBackClick')"
    />

    <v-alert
      v-if="showSuccess"
      data-testid="forgotPassword-alert-success"
      class="mt-6 px-8"
      colored-border
      color="green"
      border="left"
      elevation="2"
    >
      <p class="pa-0 ma-0 body2">
        {{ successAlertText }}
      </p>
      <p class="pa-0 ma-0 body2 font-weight-medium">{{ emailValue }}</p>
    </v-alert>

    <div v-else>
      <v-text-field
        class="body2 mt-6"
        data-testid="forgotPassword-input-email"
        dense
        outlined
        required
        v-model="emailValue"
        :rules="emailRules"
        :label="`${$t('auth.access.email')}*`"
        :placeholder="$t('auth.access.your_email')"
        @input="$emit('restoreError')"
        @keyup.enter="onClickSendInstructions"
      ></v-text-field>

      <v-alert
        v-if="showError"
        data-testid="forgotPassword-alert-error"
        class="mb-7 px-8"
        colored-border
        color="red"
        border="left"
        elevation="2"
      >
        <p class="pa-0 ma-0 body2">
          {{ $t('auth.register.there_was_a_problem_sending_you_instructions') }}
        </p>
      </v-alert>

      <Button
        block
        data-testid="forgotPassword-button-sendInstruction"
        class="mt-2"
        color="primary"
        :text="buttonText"
        @click="onClickSendInstructions"
      />

      <p class="body-1 text-center mt-6">
        {{ $t('auth.lost_password.have_email_forgot') }}
      </p>
    </div>
  </div>
</template>

<script>
import validationHelper from '@/lib/validationHelper.js'

import GoTo from './GoTo.vue'
import Button from '@/components/UI/Button'

export default {
  name: 'AccessForgotPassword',

  props: {
    email: {
      type: String,
      required: false,
    },
    showSuccess: {
      type: Boolean,
      required: false,
      default: false,
    },
    showError: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    GoTo,
    Button,
  },

  data() {
    return {
      emailValue: this.email,
      emailRules: [
        email => !!email || this.$t('validation.form.this_field_is_required'),
        email =>
          validationHelper.isValidEmailAddress(email) ||
          this.$t('onboarding.invite.invalid_email_address'),
      ],
    }
  },

  computed: {
    title() {
      return this.$t('auth.lost_password.forgot_your_password')
    },
    description() {
      return this.$t(
        'auth.lost_password.enter_your_email_address_and_we_help_you_reset_your_password'
      )
    },
    buttonText() {
      return this.$t('auth.lost_password.send_instructions')
    },
    successAlertText() {
      return this.$t('authManagePeople.instructions_have_been_sent')
    },
  },

  methods: {
    onClickSendInstructions() {
      this.$emit('onClickSendInstructions', {
        email: this.emailValue?.toLowerCase?.(),
      })
    },
  },
}
</script>
